import { sessionStateAtom } from '@/context/atoms/Session';
import { atom } from 'jotai';

export enum Permission {
  AREAS_READ = 'area_management.read',
  AREAS_WRITE = 'area_management.write',
  MAPPINGS_READ = 'mappings.read',
  MAPPINGS_WRITE = 'mappings.write',
  MAPPINGS_WRITE_RESTRICTED = 'mappings.write.restricted',
  OPERATION_GROUPS_READ = 'operation_groups.read',
  OPERATION_GROUPS_WRITE = 'operation_groups.write',
  PERMISSIONS_READ = 'permissions.read',
  PICKING_AREAS_READ = 'picking_areas.read',
  PICKING_AREAS_WRITE = 'picking_areas.write',
  PRESETS_WRITE = 'presets.write',
  ROLES_READ = 'roles.read',
  ROLES_WRITE = 'roles.write',
  SHELFLABELING_READ = 'shelf_labeling.read',
  SHELFLABELING_WRITE = 'shelf_labeling.write',
  SYSTEMSTATUS_READ = 'system_status.read',
  TEMPLATES_READ = 'templates.read',
  TEMPLATES_WRITE = 'templates.write',
  USERS_READ = 'users.read',
  USERS_WRITE = 'users.write',
  LINK_PROFILES_READ = 'link_profile.read',
  LINK_PROFILES_WRITE = 'link_profile.write',
  FINDER_READ = 'finder.read',
  FINDER_WRITE = 'finder.write',
  UPDATER_PROFILE_READ = 'updater_profile.read',
  UPDATER_PROFILE_WRITE = 'updater_profile.write',
  PICKER_PROFILES_READ = 'picker_profiles.read',
  PICKER_PROFILES_WRITE = 'picker_profiles.write',
  EKANBAN_READ = 'ekanban.read',
  EKANBAN_WRITE = 'ekanban.write',
}

export const hasRequiredPermissions = (actualPermissions: Permission[], requiredPermissions: Permission[]): boolean => {
  return requiredPermissions.every((permission) => actualPermissions.includes(permission));
};

const knownPermissions: readonly string[] = Object.values(Permission);

const isPermission = (permissionName: string): permissionName is Permission =>
  knownPermissions.includes(permissionName);

/**
 * The permissions the user has on any node, each once. Permissions workerui
 * does not know are left out, as no module could require them.
 */
export const anyNodePermissions = (permissions: readonly { readonly permissionName: string }[]): Permission[] =>
  permissions.reduce((acc: Permission[], { permissionName }) => {
    if (isPermission(permissionName) && !acc.includes(permissionName)) {
      acc.push(permissionName);
    }

    return acc;
  }, []);

export const userPermissionsAtom = atom<Permission[]>((get) =>
  anyNodePermissions(get(sessionStateAtom).user?.permissions ?? []),
);
